import React from 'react';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import TextLoop from "react-text-loop";
import { Link } from "react-router-dom";
import HeaderAbs from "../component/header/HeaderAbs";
import FooterTwo from "../component/footer/FooterTwo";
import TabTwo from "../elements/tab/TabTwo";
import ContactOne from "../elements/contact/ContactOne";
import ServiceList from "../elements/service/ServiceList";
import BlogContent2 from "../elements/blog/BlogContent2";
import Helmet from "../component/common/Helmet";

const SlideList = [
    {
        textPosition: 'text-left',
        category: 'AI Architect & FDE',
        title: 'Theo <span>Mefford</span>',
        description: (
            <>
                <strong>I architect and ship enterprise AI that drives outcomes.</strong>
                <br />
                From platform architecture to rollout, I bridge engineering and business to get agents
                into real use—reliable, governed, and observable.
            </>
        ),
        buttonText: '',
        buttonLink: ''
    }
]

const PortfolioLanding = () => {
    const title = 'What I build';
    const description =
        'I build AI systems with a platform mindset: compounding engineering, business, and shared components (retrieval, orchestration, policies, telemetry) that help product teams ship reliably in real-world constraints. ' +
        'My focus is enterprise-grade delivery: secure architecture, measurable quality, and governance-by-design.';
    const currentRole = (
        <>
            Today I'm a <strong>Principal Forward Deployed Engineer</strong> at Rackspace
            Technology working on <strong>Palantir Foundry</strong>. The role covers the whole
            arc of an engagement: I sit with the sales team to understand a customer's business
            problem and decide honestly whether Foundry is the right answer or whether something
            else fits better — and when it is the right answer, I do the initial architecture and
            solution design. From there I carry the work into proof of value and bootcamp
            alongside the customer's team and ours, then stay through full delivery, where my
            focus is AI engineering with AIP and agentic automation.
        </>
    );

    const structuredData = [
        {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Theo Mefford",
            url: "https://www.theomefford.com/",
        },
        {
            "@context": "https://schema.org",
            "@type": "Person",
            name: "Theo Mefford",
            url: "https://www.theomefford.com/",
            jobTitle: "AI Architect & Forward Deployed Engineer",
            sameAs: [
                "https://www.linkedin.com/in/temefford",
                "https://www.github.com/temefford",
            ],
        },
    ];

    const PostList = BlogContent2.slice(0 , 6);
    return (
        <div>
            <Helmet
                pageTitle="Theo Mefford"
                description="AI Architect & FDE — enterprise AI platforms, agent orchestration, and governance-by-design."
                canonical="https://www.theomefford.com/"
                structuredData={structuredData}
            />
            <HeaderAbs homeLink="/" logo="symbol-dark" color="color-black" />
            {/* Start Slider Area   */}
            <div id="home" className="fix">
                <div className="slider-wrapper">
                    {/* Start Single Slide */}
                    {SlideList.map((value , index) => (
                        <div className="slide personal-portfolio-slider slider-paralax slider-style-3 d-flex align-items-center justify-content-center bg_image bg_image--29" key={index}>
                            <div className="container">
                                <div className="row">
	                            <div className="col-lg-12">
	                                <div className={`inner ${value.textPosition}`}>                                            
	                                    {value.category ? <span>{value.category}</span> : null}
	                                    {value.title ? <h1 className="title" dangerouslySetInnerHTML={{__html: value.title}}></h1> : ''}
	                                    <h2>
	                                    <TextLoop>
	                                        <span>AI Architect.</span>
                                            <span>Forward Deployed Engineer.</span>
	                                        <span>Platform Builder.</span>
                                            <span>AI Engineer.</span>
	                                        <span>Agent Orchestration.</span>
	                                        <span>Governance + AIOps.</span>
	                                    </TextLoop>{" "}
	                                    </h2>                     
	                                    {value.description ? <h4 className="description">{value.description}</h4> : ''}
		                                    <div className="rn-hero-cta">
		                                        <Link className="rn-button-style--2 btn-solid" to="/enterprise-ai">
		                                            Enterprise AI
		                                        </Link>
		                                        <Link className="rn-button-style--2 rn-btn-dark" to="/recent-work">
		                                            Recent Work
		                                        </Link>
		                                    </div>
	                                </div>
	                            </div>
                                </div>
                            </div>
                        </div>
                    ))}
                    {/* End Single Slide */}
                </div>
            </div>
            {/* End Slider Area   */} 

            {/* Start About Area */}
            <div id="about" className="fix">
                <div className="about-area ptb--120  bg_color--1">
                    <div className="about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/portfolio/headshot.jpg" alt="About Images"/>
                                    </div>
                                </div>
                                <div className="col-lg-7">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title">{title}</h2>
                                            <p className="description">{currentRole}</p>
                                            <p className="description">{description}</p>
                                        </div>
                                        <div className="row mt--30">
                                            <TabTwo tabStyle="tab-style--1" />
                                        </div>
                                        <div className="row mt--30">
                                            <div className="col-lg-12">
                                                <details className="rn-details">
                                                    <summary className="rn-details__summary">
                                                        Earlier work &amp; research
                                                    </summary>
                                                    <div className="rn-details__content mt--15">
                                                        <p className="description">
                                                            <strong>Background / Research:</strong> Network science and physics shaped how I
                                                            approach complex systems—clear assumptions, measurable signals, and feedback loops.
                                                        </p>
                                                        <p className="description">
                                                            <strong>Leadership / Mentorship:</strong> I mentor engineers and data scientists on
                                                            production readiness and evaluation rigor; earlier in my career I taught science and
                                                            led technical learning programs.
                                                        </p>
                                                        <div className="mt--10">
                                                            <Link className="rn-button-style--2 rn-btn-dark" to="/archive">
                                                                View earlier work
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </details>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* End About Area */}

            

            {/* Start Portfolio Area 
            <div id="portfolio" className="fix">
                <div className="portfolio-area ptb--120 bg_color--5">
                    <div className="portfolio-sacousel-inner">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="section-title text-center service-style--3 mb--30 mb_sm--0">
                                        <h2 className="title">My Latest Projects</h2>                                   
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <PortfolioList styevariation="text-center mt--40" column="col-lg-4 col-md-6 col-sm-6 col-12" items="5"/>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
            End Portfolio Area */}

            {/* Start Portfolio Area */}
            <div id="portfolio" className="fix">
                <div className="rn-blog-area pt--120 bg_color--5">
                    <div className="container">
                        <div className="row align-items-end">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                                <div className="section-title text-left">
                                    <h2 className="title">Reference Architectures</h2>
                                    <h4 className="title">Deep dives: RAG, governed agents, evaluation, observability.</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row mt--60 mt_sm--40 ptb--30">
                            {PostList.map((value , i ) => (
                                <div className="col-lg-4 col-md-6 col-12" key={i}>
                                    <div className="blog blog-style--1">
                                        <div className="thumbnail">
                                            <Link to={value.ref}>
                                                <img className="w-100" src={`${value.image}`} alt="Blog Images"/>
                                            </Link>
                                        </div>
                                        <div className="content">
                                            <h4 className="title"><Link to={value.ref}>{value.title}</Link></h4>
                                            <div className="blog-text">
                                                <p>{`${value.description}`}</p>
                                            </div>
                                            <div className="blog-btn">
                                                <Link className="rn-btn text-white" to={value.ref}>Read More</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>    
                    </div>    
                </div>
            </div>
            {/* End Blog Area */}

            {/* Start Portfolio2 Area 
            <div id="portfolio" className="fix">
                <div className="rn-team-area bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                    <div className="section-title text-left service-style--3 mb--30 mb_sm--0">
                                        <h3 className="title">Latest Projects</h3>                                   
                                    </div>
                                </div>
                        </div>
                        <div className="col-lg-12">
                            <ServiceListTwo item="6" column="col-lg-4 col-md-6 col-sm-6 col-12 text-center" />
                        </div>
                    </div>
                </div>
            </div> 
            End Portfolio2 Area */}

            {/* Start Service Area  */}
            <div id="skills" className="fix">
                <div className="rn-team-area bg_color--1 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-left service-style--3 mb--30 mb_sm--0">
                                    <h2 className="title">Specialties</h2>
                                </div>
                            </div>
                            <div className="col-lg-12 ptb--20">
                                <div className="section-title text-left service-style--3 mb--30 mb_sm--0">
                                    <p className="description">
                                        <strong>I’m most effective when the constraints are real:</strong> regulated data,
                                        security boundaries, latency/cost targets, and cross-team adoption.
                                        <br />
                                        I build <strong>reusable platform capabilities</strong>—not one-off demos—so teams
                                        can ship AI safely and measure impact.
                                    </p>
                                    <p className="description">
                                        RAG + knowledge, agent orchestration, evaluation pipelines, observability, and
                                        governance controls (traceability, audit logs, safe-by-default policies).
                                    </p>
                                </div>
                            </div>
                        </div>

                        <ServiceList item="6" column="col-lg-6 col-md-6 col-sm-12 col-12" />

                        <div className="row mt--50">
                            <div
                                className="col-lg-12 d-flex justify-content-center flex-wrap"
                                style={{ gap: "12px" }}
                            >
	                                <Link className="rn-button-style--2 btn-solid" to="/enterprise-ai">
	                                    View Enterprise AI
	                                </Link>
	                                <Link className="rn-button-style--2 btn-solid" to="/recent-work">
	                                    View Recent Work
	                                </Link>
	                            </div>
	                        </div>
                    </div>
                </div>
            </div> 
            {/* End Service Area  */} 


            {/* Start COntact Area */}
            <div id="contact" className="fix">
                <div className="rn-contact-area ptb--120 bg_color--5">
                    <ContactOne />
                </div>
            </div>
            {/* End COntact Area */}

            <FooterTwo />
            {/* Start Back To Top */}
            <div className="backto-top">
                <ScrollToTop showUnder={160}>
                    <FiChevronUp />
                </ScrollToTop>
            </div>
            {/* End Back To Top */}
        </div>
    )
}

export default PortfolioLanding;
